import { render, staticRenderFns } from "./ParlamentarHeader.vue?vue&type=template&id=4c0b3b95&scoped=true&"
var script = {}
import style0 from "./ParlamentarHeader.vue?vue&type=style&index=0&id=4c0b3b95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b3b95",
  null
  
)

export default component.exports